import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      roomMeeting, // via RoomCardContainer/withState
      createJoinRoomUrl // via mutation
    } = props

    // perform GraphQL mutation
    const handleClickJoinRoom = e => {
      e.preventDefault()
      createJoinRoomUrl({
        variables: {
          roomMeetingId: roomMeeting.id
        }
      })
    }

    return <WrappedComponent onClickJoinRoom={handleClickJoinRoom} {...props} />
  }
}

export default withEventHandlers
